import React, { useState } from 'react';
import HomePage from './HomePage';
import MembersPage from './MembersPage';
import PromotionPage from './PromotionPage';
import ProductPage from './ProductPage';
import SalesPage from './SalesPage';
import ProductForm from './ProductForm';
import './App.css';
import { AiFillHome } from 'react-icons/ai';
import { MdRestaurantMenu } from 'react-icons/md';
import { FaMoneyBillWave, FaUserFriends, FaGift } from 'react-icons/fa';
import { GiKnifeFork } from 'react-icons/gi';

const navIcons = {
  Home: <AiFillHome className="nav-icon" />,
  Product: <MdRestaurantMenu className="nav-icon" />,
  Sales: <FaMoneyBillWave className="nav-icon" />,
  Members: <FaUserFriends className="nav-icon" />,
  Promotion: <FaGift className="nav-icon" />,
  Restaurant: <GiKnifeFork className="nav-icon" />,
};

function App() {
  const [currentPage, setCurrentPage] = useState('Home');

  const renderPage = () => {
    switch (currentPage) {
      case 'Members':
        return <MembersPage onNavigate={setCurrentPage} />;
      case 'Promotion':
        return <PromotionPage onNavigate={setCurrentPage} />;
      case 'Product':
        return <ProductPage onNavigate={setCurrentPage} />;
      case 'Sales':
        return <SalesPage onNavigate={setCurrentPage} />;
      case 'ProductForm':
        return <ProductForm onNavigate={setCurrentPage} />;
      default:
        return <HomePage onNavigate={setCurrentPage} />;
    }
  };

  return (
    <div className="app-root">
      {renderPage()}
      {/* 页脚 */}
      <footer className="footer">
        广州点线圆科技有限公司
      </footer>
    </div>
  );
}

export default App;
